import { atom } from "jotai";
import { RESET } from "jotai/utils";
import {
  emitEventOnWelcomeModalCloseAtom,
  zslExecutionFailedErrorMsgAtom,
  showAIStreamCreateModalAtom,
} from "@zapier/canvas-state";

import { showWelcomeModalAtom } from "./showWelcomeModalAtom";
import {
  isPromptToZslCompleteAtom,
  promptToZslErrorAtom,
} from "./streamingStatusAtoms";
import { aiPromptAtomResettable } from "./aiPromptAtom";

export const handleCloseModalCommand = atom(null, (_get, set) => {
  set(aiPromptAtomResettable, RESET); // When closing modal, we want the prompt to show up again even though we set it as empty in startOverCommand
  set(showAIStreamCreateModalAtom, false);
  set(showWelcomeModalAtom, false);
  set(zslExecutionFailedErrorMsgAtom, null);
  set(promptToZslErrorAtom, ""); // Clear out prompt => zsl error
  set(emitEventOnWelcomeModalCloseAtom);

  setTimeout(() => {
    /* Needs to be null, so no spinner when you press "Modify prompt" button.
    setTimeout is so you don't see the button text change while modal is closing. */
    set(isPromptToZslCompleteAtom, null);
  }, 1000);
});

handleCloseModalCommand.debugLabel = "handleCloseModalCommand";
